import { isNil, round, toNumber } from 'lodash';
import { action, computed, extendObservable } from 'mobx';
import moment from 'moment';
import FetchService from '../../../../core/services/FetchService';
import { formatValueByIndicator, getColorByIndicatorAndValue, groupValuesByKey } from './utils';

class LearningListService {
  fetch = new FetchService();

  constructor(indicator) {
    this.indicator = indicator;
    extendObservable(this, {
      data: [],
      global: computed(
        () => this.data && round(this.data.reduce((sum, x) => sum + toNumber(x.value), 0) / this.data.length)
      ),
      byCourse: computed(() =>
        groupValuesByKey(this.data && this.data.map((x) => ({ ...x, value: round(x.value) })), 'course', this.indicator)
      ),
    });
  }

  getFormattedValue = (value) => formatValueByIndicator(this.indicator, value);

  getFeedbackColor = (value) => getColorByIndicatorAndValue(this.indicator, value);

  load = action(() => {
    if (!this.data.length) {
      this.fetch
        .fetch({
          url: '/kpis/learning',
          query: {
            indicator: this.indicator,
            referenceMonth: moment().format('YYYY-MM'),
          },
        })
        .then(() => {
          if (this.fetch.data) {
            this.data = this.fetch.data.filter((x) => !isNil(x.value));
          } else {
            this.data = [];
          }
        });
    }
  });
}

export const CorrectAnswersRateListService = new LearningListService('CORRECT_ANSWERS_RATE');
export const LevelAdvancementRateListService = new LearningListService('LEVEL_REACHED_RATE');
